function clamp(num) {
  let min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  let max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 255;
  return Math.min(Math.max(num, min), max);
}

function getRGB(color) {
  if (color[0] === "#") {
    color = color.slice(1);
  }

  const num = parseInt(color, 16);
  const r = clamp(num >> 16);
  const g = clamp(num >> 8 & 0x00ff);
  const b = clamp(num & 0x0000ff);
  return {
    r,
    g,
    b
  };
}

export function shadeColor(color, percent) {
  var rtrn = {};
  let frontRGBA = percent < 0 ? {
    r: 255,
    g: 255,
    b: 255,
    a: Math.abs(percent)
  } : {
    r: 0,
    g: 0,
    b: 0,
    a: Math.abs(percent) || 1
  };
  let backgroundRGB = color ? getRGB(color) : {
    r: 255,
    g: 255,
    b: 255
  }; //normalize the alpha channel across the foreground and background

  rtrn.r = (1 - frontRGBA.a) * backgroundRGB.r + frontRGBA.a * frontRGBA.r;
  rtrn.g = (1 - frontRGBA.a) * backgroundRGB.g + frontRGBA.a * frontRGBA.g;
  rtrn.b = (1 - frontRGBA.a) * backgroundRGB.b + frontRGBA.a * frontRGBA.b; //check for values greater than 255

  rtrn.r = Math.min(rtrn.r, 255);
  rtrn.g = Math.min(rtrn.g, 255);
  rtrn.b = Math.min(rtrn.b, 255);
  const hexed = [rtrn.r, rtrn.g, rtrn.b].map(x => {
    const hex = Math.round(x).toString(16);
    return hex.length === 1 ? "0" + hex : hex;
  });
  return `#${hexed.join("")}`;
}